import { create } from "zustand";
import { persist } from "zustand/middleware";

type Shared3dDiceSettingState = {
  [userId: number]: boolean;
  getIsShared3dDiceSettingEnabled: (
    canUseShared3dDice: boolean,
    userId: number,
  ) => boolean;
  setIsShared3dDiceSettingEnabled: (userId: number) => void;
};

export const useShared3dDiceSettingStore = create<Shared3dDiceSettingState>()(
  persist(
    (set) => ({
      getIsShared3dDiceSettingEnabled: (
        canUseShared3dDice: boolean,
        userId: number,
      ): boolean =>
        canUseShared3dDice && useShared3dDiceSettingStore.getState()[userId],
      setIsShared3dDiceSettingEnabled: (userId: number): void => {
        set(() => ({
          ...useShared3dDiceSettingStore.getState(),
          [userId]:
            useShared3dDiceSettingStore.getState()[userId] === undefined
              ? true
              : !useShared3dDiceSettingStore.getState()[userId],
        }));
      },
    }),
    {
      name: "isShared3dDiceEnabled",
    },
  ),
);
